import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import { ArrowRightIcon } from 'lucide-react';
const services = [{
  title: 'Divorț și Partaj',
  subtitle: 'Custodie · Locuință · Bunuri comune · Pensie',
  image: 'https://images.unsplash.com/photo-1450101499163-c8848c66ca85?w=800&h=1000&fit=crop',
  to: '/divortsipartaj',
  cta: 'Vezi Pachetul Divorț și Partaj'
}, {
  title: 'Moșteniri și Succesiuni',
  subtitle: 'Drepturi succesorale · Contestații · Conflicte',
  image: 'https://images.unsplash.com/photo-1589829545856-d10d557cf95f?w=800&h=1000&fit=crop',
  to: '/mosteniri',
  cta: 'Vezi Pachetul Moșteniri'
}, {
  title: 'Pachete Penale',
  subtitle: 'Ordin de protecție · Violență · Pensie neachitată',
  image: 'https://images.unsplash.com/photo-1589994965851-a8f479c573a9?w=800&h=1000&fit=crop',
  to: '/ordindeprotectie',
  cta: 'Vezi Pachetele Penale'
}];
export function ServicesSection() {
  return <section id="servicii" className="bg-navy diagonal-pattern py-20 px-6" data-id="element-276">
      <div className="max-w-7xl mx-auto" data-id="element-277">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} className="text-center mb-16" data-id="element-278">
          <h2 className="text-text-light font-heading text-4xl md:text-5xl font-bold mb-4" data-id="element-279">
            Cum poți lucra <span className="text-gold" data-id="element-280">cu mine</span>
          </h2>
          <p className="text-text-light-secondary font-body text-lg" data-id="element-281">
            Alege domeniul juridic în care ai nevoie de ajutor acum.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8" data-id="element-282">
          {services.map((service, index) => <motion.div key={index} initial={{
          opacity: 0,
          y: 20
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          delay: index * 0.1
        }} className="bg-dark-card rounded-xl overflow-hidden border-t-[3px] border-gold flex flex-col" data-id="element-283">
              {/* Portrait image on top */}
              <div className="relative aspect-[9/10] overflow-hidden" data-id="element-284">
                <img src={service.image} alt={service.title} className="w-full h-full object-cover" data-id="element-285" />
                <div className="absolute inset-0 bg-gradient-to-t from-dark-card via-dark-card/30 to-transparent" data-id="element-286"></div>
              </div>

              <div className="p-8 flex flex-col flex-1 -mt-10 relative z-10" data-id="element-287">
                <h3 className="text-text-light font-heading text-2xl font-bold mb-2" data-id="element-288">
                  {service.title}
                </h3>
                <p className="text-gold font-label text-xs uppercase tracking-label mb-8" data-id="element-289">
                  {service.subtitle}
                </p>
                <Link to={service.to} className="mt-auto inline-flex items-center justify-center gap-2 bg-emerald text-white px-6 py-3 rounded font-label text-xs uppercase tracking-label hover:bg-emerald/90 transition-colors" data-id="element-290">
                  {service.cta}
                </Link>
              </div>
            </motion.div>)}
        </div>

        <div className="text-center mt-14" data-id="element-291">
          <Link to="/magazin" className="inline-flex items-center gap-2 border-[1.5px] border-gold text-gold px-8 py-4 rounded font-label text-sm uppercase tracking-label hover:bg-gold/10 transition-colors" data-id="element-292">
            Descoperă Toate Serviciile
            <ArrowRightIcon className="w-4 h-4" strokeWidth={2} data-id="element-293" />
          </Link>
        </div>
      </div>
    </section>;
}